export const environment = {
  production: true,
  BASE_URL: "https://api.invitte.app",
  DOMAIN: "https://invitte.app/#/",
  INVITTE_DOMAIN: "https://invitte.app",
  GOOGLE_CLIENT_ID:
    "476237591786-vn7061vporut034rvtatpim6n6bi87tm.apps.googleusercontent.com",
  PAYSTACK_PK: "pk_live_0ac6725b3a946c55c4bd6e93dcd1ee63f03ee8a4",
  webSocketBaseUrl: "wss://sandbox-api.invitte.app",
};
